import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'

import VueGtag from 'vue-gtag'

const appConfig = require('@src/app.config')

Vue.use(VueFeather)
Vue.use(flatPickr)

Vue.use(VueRouter)
Vue.use(vco)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.use(VueGtag, {
    config: {
        id: 'G-7R55TPFWVS',
        params: {
            send_page_view: true
        }
    }
}, router)

Vue.component('apexchart', VueApexCharts)


if (process.env.NODE_ENV === 'production') {
    Vue.prototype.$http = require('axios')
    Vue.prototype.$http.defaults.baseURL = appConfig.productionBasepath
}
else {
    Vue.prototype.$http = require('axios')
    Vue.prototype.$http.defaults.baseURL = appConfig.devServerUrl
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
